import type { LodgingErrorEnum } from "@b2bportal/lodging-api";
import type { PurchaseErrorEnum } from "@b2bportal/purchase-api";

/**
 * Actions that can be triggered by lodging error modal buttons
 */
export enum LodgingErrorAction {
  /** Navigate to hotel search page */
  NavigateToHotelSearch = "NavigateToHotelSearch",
  /** Navigate to My Trips page */
  NavigateToMyTrips = "NavigateToMyTrips",
  /** Open traveler picker/selector */
  OpenTravelerPicker = "OpenTravelerPicker",
  /** Go back to traveler info form */
  GoBackToTravelerInfo = "GoBackToTravelerInfo",
  /** Retry the quote operation */
  RetryQuote = "RetryQuote",
  /** Select another room */
  SelectAnotherRoom = "SelectAnotherRoom",
  /** Clear error and close modal */
  ClearError = "ClearError",
  /** No action (empty button) */
  None = "None",
}

/**
 * Button configuration for lodging error modals
 */
export interface LodgingErrorButton {
  /** Translation key for button text */
  textKey: string;
  /** Action to perform when button is clicked */
  action: LodgingErrorAction;
}

/**
 * Configuration for a single lodging error
 */
export interface LodgingErrorConfig {
  /** Translation key for error title */
  titleKey: string;
  /** Translation key for error subtitle */
  subtitleKey: string;
  /** Primary button configuration */
  primaryButton: LodgingErrorButton;
  /** Secondary button configuration (optional) */
  secondaryButton?: LodgingErrorButton;
  /** Optional CSS class for styling */
  className?: string;
}

/**
 * Context in which the lodging error occurs
 */
export type LodgingErrorContext = "CART_QUOTE" | "CART_FULFILL";

/**
 * Complete lodging error configuration map by context and error code
 */
export type LodgingErrorConfigMap = {
  [context in LodgingErrorContext]: {
    [errorCode in LodgingErrorEnum]?: LodgingErrorConfig;
  } & {
    /** Default fallback configuration */
    default: LodgingErrorConfig;
  };
};

/**
 * Purchase-level error configuration for lodging
 */
export type LodgingPurchaseErrorConfigMap = {
  [context in LodgingErrorContext]: {
    [category in PurchaseErrorEnum]?: LodgingErrorConfig;
  };
};
